const features = [
  {
    title: "Ghi nhớ thông minh",
    desc: "Thuật toán lặp lại ngắt quãng giúp bạn nhớ lâu hơn mà không cần học nhiều hơn."
  },
  {
    title: "Thiết kế tinh gọn",
    desc: "Không màu mè thừa thãi, mọi thứ đều phục vụ việc học."
  },
  {
    title: "Theo dõi tiến độ",
    desc: "Biết chính xác bạn đang mạnh ở đâu và yếu chỗ nào."
  }
];

export default function Feature() {
  return (
    <section className="features">
      {features.map((f, i) => (
        <div key={i} className="feature-card">
          <h3>{f.title}</h3>
          <p>{f.desc}</p>
        </div>
      ))}
    </section>
  );
}
